import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
The main entry point for a WishList

Referenced by page-wish-lists.liquid templates.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'urql';
import { getAccessToken } from './apps/customers/utils';
import { wishListQuery, wishListsQuery } from './apps/pages/wish-lists/queries';
import graphqlClient from './utils/graphqlClient';
import OVIDClient from './apps/customers/OVIDClient';
import WishList from './apps/pages/wish-lists/WishList';
import WishListCache from './apps/customers/WishListCache';
import { jsx as _jsx } from "react/jsx-runtime";

var init = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var search, urlParams, client, id, loggedIn, wishList, ovIDClient, response, _response, cache, _wishList$items;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            search = window.location.search; // eslint-disable-line

            urlParams = new URLSearchParams(search);
            client = graphqlClient(urlParams);
            id = urlParams.get('id');
            loggedIn = getAccessToken() !== undefined;
            wishList = null;
            ovIDClient = new OVIDClient();

            if (!id) {
              _context.next = 15;
              break;
            }

            _context.next = 10;
            return ovIDClient.query(wishListQuery, {
              id: id
            });

          case 10:
            response = _context.sent;
            wishList = response.data.wishList;

            if (!wishList) {
              window.location.assign('/404');
            }

            _context.next = 22;
            break;

          case 15:
            if (!loggedIn) {
              _context.next = 22;
              break;
            }

            _context.next = 18;
            return ovIDClient.query(wishListsQuery);

          case 18:
            _response = _context.sent;
            wishList = _response.data.wishLists.length > 0 ? _response.data.wishLists[0] : null;
            cache = new WishListCache();
            cache.cache(_response.data);

          case 22:
            if (wishList) {
              wishList.items = (_wishList$items = wishList.items) === null || _wishList$items === void 0 ? void 0 : _wishList$items.sort(function (a, b) {
                return new Date(b.createdAt) - new Date(a.createdAt);
              });
            }

            ReactDOM.render( /*#__PURE__*/_jsx(Provider, {
              value: client,
              children: /*#__PURE__*/_jsx(WishList, {
                loggedIn: loggedIn,
                wishList: wishList
              })
            }), document.getElementById('wish-list'));

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function init() {
    return _ref.apply(this, arguments);
  };
}();

init();